<template>
  <q-list
    class="column q-mx-auto full-wq"
    style="width: 100%; max-width: 800px"
  >
    <q-item
      v-for="salesItem in categoryItems"
      :key="salesItem.id"
      class="q-px-none q-py-md column"
    >
      <activity-sales-item-card
        :activity-booking="activityBooking"
        :item="salesItem"
      />
    </q-item>
  </q-list>
</template>

<script>
import ActivityBooking from 'src/models/activity/ActivityBooking'
import ActivitySalesItemCard from 'src/modules/checkout/components/ActivitySalesItemCard.vue'

export default {
  name: 'ActivitySalesCategoryPage',
  components: {
    ActivitySalesItemCard
  },
  props: {
    activityBooking: {
      type: ActivityBooking,
      required: true
    }
  },
  computed: {
    categoryItems () {
      return _(this.activityBooking.activity.activityCategories.data).map('category.items.data').flatten().value()
    }
  }
}
</script>
